var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.11 9.055C18.11 4.05406 14.0559 0 9.055 0C4.05406 0 0 4.05406 0 9.055C0 13.5745 3.31127 17.3207 7.64016 18V11.6725H5.34104V9.055H7.64016V7.06007C7.64016 4.79066 8.99204 3.53711 11.0604 3.53711C12.0508 3.53711 13.0873 3.71397 13.0873 3.71397V5.94234H11.9455C10.8207 5.94234 10.4698 6.64039 10.4698 7.35719V9.055H12.9812L12.5797 11.6725H10.4698V18C14.7987 17.3207 18.11 13.5745 18.11 9.055Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.11,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.26424fb8322b773210c3985a5e355a53.svg";
export { ForwardRef as ReactComponent };